import { render, staticRenderFns } from "./textScroll.vue?vue&type=template&id=cb02b766&scoped=true&"
import script from "./textScroll.vue?vue&type=script&lang=js&"
export * from "./textScroll.vue?vue&type=script&lang=js&"
import style0 from "./textScroll.vue?vue&type=style&index=0&id=cb02b766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb02b766",
  null
  
)

export default component.exports